import axios from 'axios'

const apiUrl = window.config.apiUrl

const formatProductDate = value => {
  const date = new Date(value)
  return (
    date.getFullYear() +
    '-' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + date.getDate()).slice(-2) +
    'T' +
    ('0' + date.getHours()).slice(-2) +
    ':' +
    ('0' + date.getMinutes()).slice(-2) +
    ':' +
    ('0' + date.getSeconds()).slice(-2)
  )
}

const formatProductDates = product => {
  product.SubmissionDate = formatProductDate(product.SubmissionDate)
  product.ReviewOneDate = formatProductDate(product.ReviewOneDate)
  product.ReviewTwoDate = formatProductDate(product.ReviewTwoDate)
  return product
}

const getPackagingCalls = products => {
  console.log('getPackagingCalls being called')
  let callArray = []
  products.forEach(product => {
    switch (product.fkCategory) {
      case '00':
        switch (product?.fkSubCategory) {
          case '001':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/plantbasedyogurt/upc/${product.UPC}`
              )
            )
            break
          case '002':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/plantbasedcheese/upc/${product.UPC}`
              )
            )
            break
          case '003':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/nutandseedbutters/upc/${product.UPC}`
              )
            )
            break
          default:
            break
        }
        break
      case '02':
        switch (product?.fkSubCategory) {
          case '001':
            callArray.push(
              axios.get(`${apiUrl}/products/cheese/upc/${product.UPC}`)
            )
            break
          case '004':
            callArray.push(
              axios.get(`${apiUrl}/products/tofu/upc/${product.UPC}`)
            )
            break
          default:
            break
        }
        break
      case '03':
        switch (product?.fkSubCategory) {
          case '005':
            callArray.push(
              axios.get(`${apiUrl}/products/eggs/upc/${product.UPC}`)
            )
            break
          default:
            break
        }
        break
      case '05':
        switch (product?.fkSubCategory) {
          case '001BC':
            callArray.push(
              axios.get(
                `${apiUrl}/products/bsbreakfastcereal/breakfastcereal/upc/${product.UPC}`
              )
            )
            break
          case '001IO':
            callArray.push(
              axios.get(
                `${apiUrl}/products/bsbreakfastcereal/instantoatmeal/upc/${product.UPC}`
              )
            )
            break
          default:
            break
        }
        break
      case '06':
        switch (product?.fkSubCategory) {
          case '001':
            callArray.push(
              axios.get(
                `${apiUrl}/products/legumes/Peanut Butter/upc/${product.UPC}`
              )
            )
            break
          case '002':
            callArray.push(
              axios.get(
                `${apiUrl}/products/legumes/Dry Beans, Peas, Lentils/upc/${product.UPC}`
              )
            )
            break
          case '003':
            callArray.push(
              axios.get(
                `${apiUrl}/products/legumes/Canned Mature Beans/upc/${product.UPC}`
              )
            )
            break
          default:
            break
        }
        break
      case '08':
        callArray.push(
          axios.get(`${apiUrl}/products/cannedfish/upc/${product.UPC}`)
        )
        break
      case '09':
        switch (product?.fkSubCategory) {
          case '001BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/infant/cereal/upc/${product.UPC}`
              )
            )
            break
          default:
            break
        }
        break
      case '12':
        switch (product?.fkSubCategory) {
          case '001':
          case '002':
          case '003':
          case '101':
          case '102':
          case '103':
            callArray.push(
              axios.get(
                `${apiUrl}/products/infant/fruitsandvegetables/upc/${product.UPC}`
              )
            )
            break
          case '001BS':
          case '002BS':
          case '003BS':
          case '101BS':
          case '102BS':
          case '103BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/infant/fruitsandvegetables/upc/${product.UPC}`
              )
            )
            break
          case '001RFI':
          case '002RFI':
          case '003RFI':
          case '101RFI':
          case '102RFI':
          case '103RFI':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/rfi/infant/fruitsandvegetables/upc/${product.UPC}`
              )
            )
            break
          default:
            break
        }
        break
      case '13':
        switch (product?.fkSubCategory) {
          case '001':
          case '101':
            callArray.push(
              axios.get(`${apiUrl}/products/infant/meats/upc/${product.UPC}`)
            )
            break
          case '001BS':
          case '101BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/infant/meats/upc/${product.UPC}`
              )
            )
            break
          case '001RFI':
          case '101RFI':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/rfi/infant/meats/upc/${product.UPC}`
              )
            )
            break
          default:
            break
        }

        break
      case '16':
        switch (product?.fkSubCategory) {
          case '001':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholegrains/Whole Grain Bread/upc/${product.UPC}`
              )
            )
            break
          case '003':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholegrains/Brown Rice/upc/${product.UPC}`
              )
            )
            break
          case '004':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholegrains/Bulgur/upc/${product.UPC}`
              )
            )
            break
          case '005':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholegrains/Oats or Oatmeal/upc/${product.UPC}`
              )
            )
            break
          case '005BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/oatsoatmeal/upc/${product.UPC}`
              )
            )
            break
          case '006':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholegrains/Barley/upc/${product.UPC}`
              )
            )
            break
          case '007':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholegrains/corntortilla/upc/${product.UPC}`
              )
            )
            break
          case '007BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/bswholegrains/corntortilla/upc/${product.UPC}`
              )
            )
            break
          case '008':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholegrains/wheattortilla/upc/${product.UPC}`
              )
            )
            break
          case '008BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/bswholegrains/wheattortilla/upc/${product.UPC}`
              )
            )
            break
          case '009':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholegrains/wheatpasta/upc/${product.UPC}`
              )
            )
            break
          case '009BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/bswholegrains/wheatpasta/upc/${product.UPC}`
              )
            )
            break
          case '010BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/wholewheatbagels/upc/${product.UPC}`
              )
            )
            break
          case '011BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/wholewheatenglishmuffins/upc/${product.UPC}`
              )
            )
            break
          case '012BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/wholewheatpitabread/upc/${product.UPC}`
              )
            )
            break
          case '010':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholewheatbagels/upc/${product.UPC}`
              )
            )
            break
          case '011':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholewheatmuffins/upc/${product.UPC}`
              )
            )
            break
          case '012':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholewheatpitabread/upc/${product.UPC}`
              )
            )
            break
          case '013':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/wholewheatnaan/upc/${product.UPC}`
              )
            )
            break
          case '014':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/quinoa/upc/${product.UPC}`
              )
            )
            break
          case '015':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/wildrice/upc/${product.UPC}`
              )
            )
            break
          case '016BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/cornmasaflour/upc/${product.UPC}`
              )
            )
            break
          case '017BS':
            callArray.push(
              axios.get(
                `${apiUrl}/products/brandspecific/cornmeal/upc/${product.UPC}`
              )
            )
            break
          case '016':
            callArray.push(
              axios.get(`${apiUrl}/products/cornmasaflour/upc/${product.UPC}`)
            )
            break
          case '017':
            callArray.push(
              axios.get(
                `${apiUrl}/products/wholegraincornmeal/upc/${product.UPC}`
              )
            )
            break
          default:
            break
        }
        break
      case '50':
        switch (product?.fkSubCategory) {
          case '001':
          case '002':
            callArray.push(
              axios.get(`${apiUrl}/products/yogurt/upc/${product.UPC}`)
            )
            break
          default:
            break
        }
        break
      case '51':
        callArray.push(
          axios.get(`${apiUrl}/products/milk/Whole Milk/upc/${product.UPC}`)
        )
        break
      case '52':
        switch (product?.fkSubCategory) {
          case '002':
          case '004':
          case '006':
          case '012':
          case '014':
          case '019':
            callArray.push(
              axios.get(
                `${apiUrl}/products/milk/Reduced Fat/upc/${product.UPC}`
              )
            )
            break
          case '011':
            callArray.push(
              axios.get(`${apiUrl}/products/plantmilk/upc/${product.UPC}`)
            )
            break
          default:
            break
        }

        break
      case '55':
        switch (product?.fkSubCategory) {
          case '001':
          case '002':
          case '003':
          case '004':
          case '005':
          case '006':
          case '007':
          case '008':
            callArray.push(
              axios.get(`${apiUrl}/products/plantmilk/upc/${product.UPC}`)
            )
            break
          default:
            break
        }

        break
      case '54':
        callArray.push(axios.get(`${apiUrl}/products/juice/upc/${product.UPC}`))
        break
      case '19':
        switch (product?.fkSubCategory) {
          case '001FF':
          case '001FV':
            callArray.push(
              axios
                .get(
                  `${apiUrl}/products/fruitsandvegetables/Vegetable/frozen/upc/${product.UPC}`,
                  {
                    validateStatus: status => {
                      return status < 500
                    },
                  }
                )
                .then(response => {
                  if (response.data.statusCode === 400) {
                    return axios.get(
                      `${apiUrl}/products/fruitsandvegetables/Fruit/frozen/upc/${product.UPC}`
                    )
                  } else {
                    return response
                  }
                })
            )
            break
          case '001CF':
          case '001CV':
            callArray.push(
              axios
                .get(
                  `${apiUrl}/products/fruitsandvegetables/Vegetable/canned/upc/${product.UPC}`,
                  {
                    validateStatus: status => {
                      return status < 500
                    },
                  }
                )
                .then(response => {
                  if (response.data.statusCode === 400) {
                    return axios.get(
                      `${apiUrl}/products/fruitsandvegetables/Fruit/canned/upc/${product.UPC}`
                    )
                  } else {
                    return response
                  }
                })
            )
            break
          case '004':
            callArray.push(
              axios.get(
                `${apiUrl}/products/legumes/Dried Fruits/upc/${product.UPC}`
              )
            )
            break
          default:
            break
        }
        break
      default:
        break
    }
  })
  return callArray
}

export const loadProducts = (products, eventType, dispatch) => {
  let packagingCalls = getPackagingCalls(products)
  let productsPayload = []
  Promise.all(packagingCalls).then(packagesResponses => {
    // loop over all the packages data
    console.log('length of products is: ' + products.length)
    console.table(products)
    console.log('length of packagesResponses is: ' + packagesResponses.length)
    console.table(packagesResponses)
    for (let index = 0; index < packagesResponses.length; index++) {
      // parse out a package's JSON
      let currentPackage = [{}]
      if (packagesResponses[index]?.data?.statusCode === 200) {
        currentPackage = JSON.parse(packagesResponses[index].data.result)
      }
      // merge the packaging data with product data
      let productAndPackage = {
        ...products[index],
        ...currentPackage[0],
      }

      productAndPackage = formatProductDates(productAndPackage)

      // add the merged object to the array of all products
      productsPayload = [...productsPayload, productAndPackage]
    }
    dispatch({
      type: eventType,
      payload: productsPayload,
    })
  })
}

export const loadReviewerProducts = (products, eventType, dispatch) => {
  const productsPayload = products.map(product => {
    const productSpecific =
      typeof product.ProductSpecific === 'string'
        ? JSON.parse(product.ProductSpecific)
        : product.ProductSpecific || {}
    const generalProduct = { ...product }
    delete generalProduct.ProductSpecific

    return formatProductDates({
      ...generalProduct,
      ...productSpecific,
    })
  })

  dispatch({
    type: eventType,
    payload: productsPayload,
  })
}

export const isNotAlpha = key => {
  if (
    !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(key) &&
    (key.toLowerCase() < 'a' || key.toLowerCase() > 'z')
  ) {
    return true
  }
}

export const isNotNumeric = key => {
  if (
    !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(key) &&
    (key < '0' || key > '9')
  ) {
    return true
  }
}

export const isNotNumericDecimal = key => {
  if (
    !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', '.'].includes(
      key
    ) &&
    (key < '0' || key > '9')
  ) {
    return true
  }
}

export const isComma = key => {
  if (key === ',') {
    return true
  }
}
